import { CurrentDate } from 'components/Shared/DateTimePicker/DateTimePicker.types';
import { SessionTypeItem } from './sessionLogs.types';

export const allOption: SessionTypeItem = { code: 'all', label: 'All' };
export const emptyDate: CurrentDate = {
  from: null,
  to: null
};
